import * as React from 'react';
import { pointerDirection } from 'types';
import classNames from 'utils/classNames';
import './tooltip.css';

interface TooltipProps {
  /**
   * render function that returns children elements
   * ie. TooltipContent
   */
  children?: JSX.Element | JSX.Element[];
  /**
   * CSS absolute values for location of tooltip
   */
  fixedLocation: {
    top?: number;
    right?: number;
    left?: number;
    bottom?: number;
  };
  /**
   * boolean value on whether the tooltip is visible or hidden
   *  true: visible
   *  false: hidden
   */
  isShown: boolean;
  /**
   * Value to specify the direction of the pointer/cursor
   */
  placement: pointerDirection;
  /**
   * Value to specify default styles bases on a theme, ie light | dark | grey
   */
  theme?: string;
  pointerPlacement?: {
    top?: number;
    left?: number;
    bottom?: number;
    right?: number;
  };
}

const Tooltip = React.forwardRef(
  (props: TooltipProps, ref): JSX.Element => (
    <div
      className={classNames({
        [props.placement]: true,
        isShown: props.isShown,
        tooltipWrapper: true,
        ...(props.theme ? { [props.theme]: true } : {}),
      })}
      style={props.fixedLocation}
      // @ts-ignore
      ref={ref}
    >
      {props.children}
      <span className="tip" style={{ ...(props.pointerPlacement || {}) }} />
    </div>
  ),
);

export default Tooltip;
